(function () {
    window.initCertificates = function (labels) {
        var options = document.querySelector('[data-certificate-options]');
        var contact = document.querySelector('[data-certificate-contact]');
        if (!options || !contact) return;
        var phone = contact.elements.phone;
        var prefix = contact.elements.phonePrefix;
        var error = contact.querySelector('[data-contact-error]');
        document.querySelector('[data-certificate-scroll]').addEventListener('click', function () {
            document.getElementById('certificate-request').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        var busy = false;
        var submitted = false;
        var mask = null;
        function digits(value) {
            return String(value).replace(/\s/g, '');
        }
        function validateOptions() {
            var sum = digits(options.elements.sum.value);
            var amount = options.elements.amount.value;
            var sumOK = /^\d+$/.test(sum) && Number(sum) >= 100000;
            var amountOK = /^\d+$/.test(amount) && Number(amount) >= 1;
            options.querySelector('[data-error="sum"]').textContent = sumOK ? '' : labels.sumError;
            var amountError = options.querySelector('[data-error="amount"]');
            if (amountError) amountError.textContent = amountOK ? '' : labels.amountError;
            return sumOK && amountOK;
        }
        function updateMask(clear) {
            var code = contact.querySelector('.pseudo-select .select .code');
            if (clear) phone.value = '';
            if (window.IMask && code) {
                if (mask) mask.destroy();
                mask = window.IMask(phone, { mask: (code.dataset.mask || '(999) 999-99-99').replace(/9/g, '0'), lazy: false });
            }
        }
        options.addEventListener('change', function (event) {
            if (event.target.name === 'preset') {
                options.elements.sum.value = Number(event.target.value).toLocaleString('ru-RU');
                options.querySelector('[data-error="sum"]').textContent = '';
            }
        });
        options.elements.sum.addEventListener('input', function () {
            options.querySelectorAll('[name="preset"]').forEach(function (radio) {
                radio.checked = false;
            });
        });
        prefix.addEventListener('change', function () {
            updateMask(true);
        });
        options.addEventListener('submit', function (event) {
            event.preventDefault();
            if (!validateOptions()) return;
            window.modal.open({
                header: { title: labels.title },
                content: { htmlDetachSelectorId: 'certificate-contact' },
                type: window.modal.types.FLOATING,
                parentCssClass: 'certificate-modal',
                footer: null,
                onAfterShow: function onAfterShow() {
                    updateMask(false);
                }
            });
        });
        contact.addEventListener('submit', function (event) {
            event.preventDefault();
            if (busy || submitted || !contact.reportValidity()) return;
            if (!validateOptions()) {
                error.textContent = labels.sumError + '. ' + labels.amountError;return;
            }
            var code = contact.querySelector('.pseudo-select .select .code');
            var phonePrefix = (code ? code.textContent : prefix.value).replace(/\D/g, '');
            if (phonePrefix.length + phone.value.replace(/\D/g, '').length < Number(code ? code.dataset.min : 11)) {
                error.textContent = labels.phoneError;return;
            }
            var body = new FormData(contact);
            body.set('phonePrefix', phonePrefix);
            body.set('sum', options.elements.sum.value);
            body.set('amount', options.elements.amount.value);
            var button = contact.querySelector('[type="submit"]');
            busy = true;button.disabled = true;error.textContent = '';
            fetch(contact.action, { method: 'POST', body: body, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(function (response) {
                return response.json().then(function (data) {
                    if (!response.ok || data.success !== true) {
                        error.textContent = data.errors ? Object.keys(data.errors).map(function (key) {
                            return data.errors[key].join(' ');
                        }).join(' ') : labels.saveError;
                        return;
                    }
                    submitted = true;
                    contact.hidden = true;
                    document.querySelector('[data-certificate-success]').hidden = false;
                });
            }).catch(function () {
                error.textContent = labels.saveError;
            }).finally(function () {
                busy = false;button.disabled = submitted;
            });
        });
    };
})();